module.exports = "<table class=\"table\">\n  <tbody>\n    <tr ng-repeat=\"key in $ctrl.keys track by $index\">\n      <td ng-bind=\"key.toUpperCase() | translate\"></td>\n      <td ng-bind=\"$ctrl.data[key]\"></td>\n    </tr>\n  </tbody>\n</table>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/utility/table-responsive/table-responsive.html
 ** module id = 251
 ** module chunks = 0
 **/